import postalCodes from 'postal-codes-js';
import * as yup from 'yup';

import { getPostalCodeHint } from '../lib/postal-code-hint';

export const addressYupSchema = yup.object().shape({
  addressLine1: yup.string().required('A street address is required'),
  city: yup.string().required('A city is required'),
  stateOrArea: yup.string().when('countryCode', {
    is: 'USA',
    then: yup.string().required('A state or area is required'),
    otherwise: yup.string(),
  }),
  countryCode: yup.string().required('A country code is required'),
  postalCode: yup
    .string()
    .required('A zip/postal code is required')
    .test('postalCode', 'Zip code is not valid', (value, context) => {
      const { countryCode } = context.parent;
      const validPostcode = postalCodes.validate(countryCode, value ?? '');
      const isValid = typeof validPostcode === 'string' ? false : !!validPostcode;
      if (isValid) return true;
      const hint = getPostalCodeHint(countryCode);
      const message = hint
        ? `Zip code is not valid. Expected format: ${hint.pattern} (e.g. ${hint.example})`
        : 'Zip code is not valid';
      return context.createError({ message });
    }),
});
